(function ($, Drupal, once) {
  'use strict';

  /**
   * Main Menu Click Function.
   */
  const MenuToggle = function (drupalMenu, event) {
    updateBackButton(drupalMenu);
    let clickedEntry = $(event.target);
    if (clickedEntry[0].tagName === 'UL') {
      event.preventDefault();
      return false;
    }

    // Walk up to the nearest enclosing menu-item. Leaf items always
    // navigate directly — without this, clicks on nested span/icon
    // elements inside the link would fall through to the toggle logic.
    const clickedLi = clickedEntry.closest('li.menu-item');
    if (clickedLi.length && !clickedLi.hasClass('menu-item--expanded')) {
      return true;
    }

    clickedEntry = clickedEntry.parent();
    if (!clickedEntry.hasClass('menu-item--expanded')) {
      return true;
    }
    event.preventDefault();
    let rootMenuEntry = clickedEntry.closest('.menu-level-1').parent();
    clickedEntry.addClass('open');
    rootMenuEntry.length > 0 ? rootMenuEntry.addClass('open') : null;
    drupalMenu.find('.menu-item').each(function () {
      const currentMenu = $(this);
      currentMenu.hasClass('open') ? currentMenu.removeClass('open') : currentMenu.addClass('closed');
    });
    clickedEntry.toggleClass('closed');
    let parent = clickedEntry.parent().parent();
    clickedEntry.hasClass('closed') ? parent.removeClass('borderless') : parent.addClass('borderless');
    updateBackButton(drupalMenu);
  };

  /**
   * Show or hide the back icon, depending on the open menu items.
   */
  const updateBackButton = (drupalMenu) => {
    const openMenus = drupalMenu.find('.menu-item:not(.closed)');
    const backArrow = $('.operations .back .fa-arrow-left');
    if (openMenus.length > 0) {
      backArrow.removeClass('js-hide');
    } else {
      backArrow.addClass('js-hide');
    }
  };

  /**
   * Toggle main menu visibility.
   */
  const showHideMenu = (drupalMenu) => {
    drupalMenu.toggleClass('visible');
    drupalMenu.find('.open').removeClass('open');
    drupalMenu.find('.menu-item:not(.closed)').addClass('closed');
    drupalMenu.find('.borderless').removeClass('borderless');
    $('body').toggleClass('no-scroll');
    updateBackButton(drupalMenu);
  };

  /**
   * Open the Main menu and animate navigation to sub-menu.
   */
  const menuDeepLink = (drupalMenu, event) => {
    const targetLink = $(event.target).attr('href');
    const targetTitle = $(event.target).text().trim();
    let link = drupalMenu.find(`a[href="${targetLink}"]`);

    if (link.length < 2 && targetTitle) {
      const titleMatch = drupalMenu.find('.menu-item--expanded > a.submenu').filter(function () {
        return $(this).text().trim() === targetTitle;
      });
      if (titleMatch.length > 0) {
        link = titleMatch;
      }
    }

    if (link.length < 1) {
      return true;
    }

    // Only open the fly-in when the matching main-menu item actually
    // has children. Leaf items (Erfolgsstorys, Kontakt, Suche, …)
    // navigate directly — checking on the main-menu side because the
    // quickmenu is rendered flat and never carries menu-item--expanded.
    const matchedExpanded = link.toArray().some(
      (el) => el.parentElement && el.parentElement.classList.contains('menu-item--expanded')
    );
    if (!matchedExpanded) {
      return true;
    }

    event.preventDefault();
    showHideMenu(drupalMenu);

    const parentLinks = [];
    let currentItem = link.closest('.menu-item--expanded');
    while (currentItem.length > 0) {
      const parentLink = currentItem.find('> a.submenu');
      if (parentLink.length > 0) {
        parentLinks.unshift(parentLink[0]);
      }
      currentItem = currentItem.parent().closest('.menu-item--expanded');
    }

    let delay = 150;
    parentLinks.forEach((parentLink, index) => {
      setTimeout(() => {
        parentLink.click();
      }, delay + (index * 200));
    });
  };

  /**
   * Attach menu behavior. Runs on initial page load and after every AJAX
   * response, guarded by once() so handlers are only attached a single time
   * per element. Uses Drupal.behaviors so it is safe to load the script
   * either in the header or footer — attachment waits for DOM readiness.
   */
  Drupal.behaviors.ibwNavigation = {
    attach: function (context) {
      const menuNodes = once('ibw-navigation', '#block-ibw-main-menu, #block-hwsgr-main-menu', context);
      if (menuNodes.length === 0) {
        return;
      }
      const drupalMenu = $(menuNodes);
      const quickMenu = $('#block-quickmainmenu, #block-hwsgr-quickmainmenu', context);

      // Copy Menu parents to sub-menus as clickable link.
      drupalMenu.find('.menu-item--expanded').each(function () {
        const item = $(this);
        if (!item.data('menu-cloned')) {
          item.find('> a').clone().wrap('<li></li>').prependTo(item.find('> .menu'));
          item.data('menu-cloned', true);
        }
      });

      // Menu Entry click listener.
      drupalMenu.on('click', (event) => MenuToggle(drupalMenu, event));

      // Operations click listeners.
      drupalMenu.find('.operations .back').on('click', function () {
        let openMenus = drupalMenu.find('.menu-item:not(.closed)');
        $(openMenus[openMenus.length - 1]).addClass('closed');
      });

      // Show and hide the main menu.
      drupalMenu.find('.operations .close, .background').on('click', () => showHideMenu(drupalMenu));
      quickMenu.find('.menu-icon').on('click', () => showHideMenu(drupalMenu));

      // Show the main menu and navigate to deep-link.
      quickMenu.find('ul.menu li.menu-item a').on('click', (event) => menuDeepLink(drupalMenu, event));
    },
  };
})(jQuery, Drupal, once);
